module.exports = __webpack_public_path__ + "img/lock.e9665e8d.svg";